import * as React from 'react';
import { flow, forEach } from 'lodash';
import { Col, Row } from 'react-bootstrap';
import { IChannel, IPremium, IProduct } from '../../../../data/api/models';
import { connect } from 'react-redux';
import { IQuoteState } from '../../../../services/quote/models';
import SidebarQuoteSummary from './components/SidebarQuoteSummary';
import { IStore } from '../../../../redux/IStore';
import { reduxForm } from 'redux-form';
import { withRouter } from 'react-router';
import ContactUsModal from '../ContactUsModal';
import UsefulDocumentsModal from '../UsefulDocumentsModal';
import { Link } from 'react-router-dom';

interface IQuoteSidebarProps {
  quote: IQuoteState;
  product: IProduct;
  channel: IChannel;
  location: any;
  step?: string;
}

interface IQuoteSidebarState {
  resize: boolean;
}

class QuoteSidebar extends React.Component<IQuoteSidebarProps, IQuoteSidebarState> {

  public state: IQuoteSidebarState = {
    resize: false,
  };

  public componentDidMount() {
    window.addEventListener('resize', this.resize.bind(this));
    this.resize();
  }

  public resize() {
    this.setState({ resize: window.innerWidth <= 640 });
  }

  private renderUsefulDocuments = () => {
    const { channel } = this.props;
    const {resize} = this.state;
    let i = 1;

    const documents = (
      <div>
        {channel.productDocuments.map((document, index) => {
          if (resize && document.shortName === 'Insurance Product Information Document') {
            document.shortName = 'Insurance Product Information';
          }

          if (document.shortName === 'Terms of Business Customer Agreement') {
            document.shortName = 'Terms of Business';
          }
          if (document.shortName === 'Privacy Notice') {
            document.shortName = 'GDPR Privacy Notice';
          }

          if (['Policy Wording: Horsebox Breakdown'].includes(document.name)) {
            document.shortName = document.name;
          }

          if (['Horsebox - Breakdown Cover Available'].includes(document.name)) {
            return <div />;
          }

          return (
            <div key={index}>
              <Row key={index} className={'documents'}>
                <Col sm={12}>
                  <a
                    className="full-width document-btn-text-left docs-modal-container"
                    href={document.filePath}
                    target="_blank"
                  >
                    <img src={require('../../img/file_pdf_green.svg')} alt="" style={{ width: '30px' }} />
                    {' '}{document.shortName}
                  </a>
                </Col>
              </Row>
              {i++ !== channel.productDocuments.length && (
                <hr />
              )}
            </div>
          );
        })}
      </div>
    );

    return (
      <div>
        <Row>
          <Col sm={12} className="sidebar-content-container-primary">
            <h3>Useful Documents</h3>
            <div className="centre-sidebar-components">
              <UsefulDocumentsModal
                documents={documents}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  private renderRetrieveQuotes = () => {
    return (
      <div>
        <Row>
          <Col sm={12} className="sidebar-content-container-primary">
            <h3>Retrieve Quotes</h3>
            <div className="centre-sidebar-components">
              <Link to="/auth/login" className="center green-background btn btn-default">
                <img src={require('../../img/sign-in.svg')} alt="Login" className="signin-size"/>
              </Link>
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  private renderContactUs = () => {
    const { channel } = this.props;

    return (
      <div>
        <Row>
          <Col sm={12} className="sidebar-content-container-secondary">
            <h3>Contact Us</h3>
            <div className="centre-sidebar-components">
              <ContactUsModal channel={channel} />
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  private renderQuoteSummary = () => {
    const { quote, product, channel } = this.props;
    const quotes = quote.quotes;
    const schemeId = quote.application.schemeId;

    if (! quotes) {
      return null;
    }

    let premium: IPremium = null;

    forEach(quotes, (tripTypes) => {
      forEach(tripTypes, (quotedPremium) => {
        if (!quotedPremium) {
          return null;
        }

        if (quotedPremium.scheme.id === schemeId) {
          premium = quotedPremium;
        }
      });
    });

    if (quote.complete) {
      return null;
    }

    return (
      <div>
        <SidebarQuoteSummary
          product={product}
          channel={channel}
        />
      </div>
    );
  }

  public render() {
    const { step } = this.props;
    return (
      <div className="quote-sidebar">
        {step !== 'complete' && (
          <>{this.renderQuoteSummary()}</>
        )}
        {step === 'declaration' && (
          <>{this.renderRetrieveQuotes()}</>
        )}
        {this.renderContactUs()}
        {step !== 'complete' && (
          <>{this.renderUsefulDocuments()}</>
        )}
      </div>
    );
  }
}

export default flow([
  reduxForm({
    form: 'quote-sidebar',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  connect(
    (state: IStore) => ({
      quote: state.quote,
      channel: state.branding.channel,
    }),
  ),
  withRouter,
])(QuoteSidebar);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/components/QuoteSidebar/index.tsx